import httpManager from "@/app/shared/utils/httpManager";

export async function getEmailHistory(emailId) {
  const response = await httpManager.get(`/mail/threads/${emailId}/`);
  return response?.data;
}
